import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';
import { License } from 'src/app/modules/shared/model/license.model';
import { PublicAccountSubmission } from 'src/app/modules/shared/model/publicAccountSubmission.model';
import { StringKeyValue } from 'src/app/modules/shared/model/stringKeyValue.model';
import { NavigationService } from 'src/app/modules/shared/services/navigation-service.service';
import { SettingService } from 'src/app/modules/shared/services/setting.service';
import { GFilterViewIdRepo } from 'src/app/repo/GFilterViewIds.repo';
import { addUserModels } from 'src/app/state/actions/loggedin-user.actions';
import { addPublicUserAccounts } from 'src/app/state/actions/public-user-account.actions';
import { selectAppSettings } from 'src/app/state/selectors/app-settings.selectors';
import { LicenseService } from '../../services/license.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'register-license-screen',
  templateUrl: './register-license-screen.component.html',
  styleUrls: ['./register-license-screen.component.less']
})
export class RegisterLicenseScreenComponent implements OnInit, OnDestroy {

  adminMode = false;

  module = '';
  detailViewId = GFilterViewIdRepo.RegisterLicense;

  licenseTypes: StringKeyValue[];
  licenseForm: UntypedFormGroup;

  licenseNotFound = false;
  existingUser: string;
  processing = false;
  protected destroyActions = new Subject<boolean>();

  constructor(private store: Store<AppState>, private formBuilder: UntypedFormBuilder, private navigationService: NavigationService,
      private settingsService: SettingService, private licenseService: LicenseService, private activatedRoute: ActivatedRoute) {
    this.licenseForm = this.formBuilder.group({
      licenseType: '',
      licenseNumber: ''
    });
    this.licTypeControLRef.setValidators([Validators.required]);

    this.activatedRoute.queryParams.subscribe(params => {
      const userParam = params['existingUser'];
      if(userParam){
        let userData = decodeURI(userParam);
        if (userData ) {
            this.existingUser = userData.split(' ').join('+');
        }
      }
    });

   }

  public get licNumberControLRef(): UntypedFormControl {
    return this.licenseForm.controls['licenseNumber'] as UntypedFormControl;
  }

  public get licTypeControLRef(): UntypedFormControl {
    return this.licenseForm.controls['licenseType'] as UntypedFormControl;
  }

  ngOnInit(): void {
    this.store.select(selectAppSettings)
      .pipe(takeUntil(this.destroyActions))
      .subscribe({
        next: state => {
      this.adminMode = state.AdminMode;
    }});

    this.settingsService.getLicenseTypes().subscribe((types)=>{
      this.licenseTypes = types;
    });
  }

  getInputLabel() {
    return `${this.licTypeControLRef.value} License`;
  }

  validateForm(): boolean {
    let valid = true;
    this.licenseForm.updateValueAndValidity();
    for (const simpleElemName in this.licenseForm.controls) {
      if ({}.hasOwnProperty.call(this.licenseForm.controls, simpleElemName)) {
        const formControl = this.licenseForm.controls[simpleElemName] as UntypedFormControl;
        if (formControl.validator) {
          formControl.markAsDirty();
        }
        if (formControl.errors && Object.keys(formControl.errors).length > 0) {
          valid = false;
        }
      }
    }

    return valid;
  }


  submit(event){
    //validate license form
    if(!this.validateForm()){
      return;
    }

    const licenseModel: License = {
      licenseNum: this.licenseForm.controls['licenseNumber'].value,
      licenseType: this.licenseForm.controls['licenseType'].value
    };
    this.licenseForm.markAsPristine();

    //Validate license
    this.licenseService.validateLicenseLink(licenseModel).subscribe((license)=>{
      if(license){
        const accountModel = {
          licenseLinks: [license]
        } as PublicAccountSubmission;

        this.store.dispatch(addPublicUserAccounts({PublicUserAccount: accountModel}));
        if(this.existingUser)
        {
          this.navigationService.navigateRoute('account/register-contact-detail', [{ Key: 'existingUser', Value: this.existingUser }])
        } else {
          this.navigationService.navigateRoute('account/new');
        }
      } else {
        this.licenseNotFound = true;
      }
    }
    ,err => {
        this.licenseNotFound = true;
    });

  }

  back() {
    if (this.adminMode) {
      return;
    }
    this.navigationService.navigateLegacyPage(this.navigationService.getHomePageUrl());
  }


  ngOnDestroy(): void {
    this.destroyActions.next();
    this.destroyActions.complete();
  }

}
